<template>
  <form @submit.prevent="onSearch" class="mt-3 mb-3">
    <div class="row ">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              placeholder="Standort"
          />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="clientDropdown && clientDropdown.length">
          <SelectVue
              v-model="filters.clientId"
              :options="clientDropdown"
              :is-clear="true"
              placeholder="Kostenträger"
          />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="courseNameDropdown && courseNameDropdown.length">
          <SelectVue
              v-model="filters.courseId"
              :options="courseNameDropdown"
              :is-clear="true"
              placeholder="Maßnahme"
          />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="billingTypeDropdown && billingTypeDropdown.length">
          <SelectVue
              v-model="filters.billingType"
              :options="billingTypeDropdown"
              :is-clear="false"
          />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <Datepicker
            :disabled="filters.billingType === 'endabrechnung'"
            v-model="filters.startDate"
            position="down"
            placeholder="Startdatum" />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            placeholder="Enddatum" />
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox
            v-if="filters.billingType !== 'pauschalabrechnung'"
            v-model="filters.signed"
            :labelPosition="'right'"
            label="Unterschriftspflichtig"/>
      </div>

      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs, watch } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Reactive filters
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  courseNameDropdown: {
    type: Array,
    required: true,
  },
  billingTypeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Use toRefs to maintain reactivity
const { filters }         = toRefs(props);
const officeDropdown      = toRefs(props)[ 'officeDropdown' ];
const clientDropdown      = toRefs(props)[ 'clientDropdown' ];
const courseNameDropdown  = toRefs(props)[ 'courseNameDropdown' ];
const billingTypeDropdown = toRefs(props)[ 'billingTypeDropdown' ];
const emit                = defineEmits([ 'search' ]);


watch(() => filters.value.billingType, (newBillingType) => {
  if (newBillingType === 'endabrechnung') {
    filters.value.startDate = '';
  }
});

function onSearch() {
  emit('search', filters.value);
}

</script>

<style scoped>
/* Add any custom styles for your search component */
</style>
